module.exports = __webpack_public_path__ + "media/images/donation/pay-easy-12450b5d1f653a0959c00c08aea35467.png";